import React, { useState } from "react";

const ModalComponent = ({
  isOpen,
  onClose,
  selectedPackage,
  onConfirm,
  packageData,
  getSelectedServices,
  services,
  getPrice,
}) => {
  const [selectedServices, setSelectedServices] = useState([]);

  const handleCheckboxChange = (service) => {
    setSelectedServices((prev) =>
      prev.includes(service)
        ? prev.filter((item) => item !== service)
        : [...prev, service]
    );
  };

  const servicesList = [
    "Background Check",
    "Reference Verification",
    "Employment History",
    "Criminal Record Check",
    "Credit Check",
    "Education Verification",
  ];
  // console.log("getSelectedServices", getSelectedServices, selectedPackage);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0   overflow-y-auto  bg-gray-200 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white overflow-y-auto  rounded-3xl p-4  w-full max-w-3xl mx-4 shadow-lg relative border border-gray-300">
        <div className="border-b-2 py-2 ">
          <button
            onClick={onClose}
            className="absolute top-7 right-6 text-gray-500 font-bold hover:text-gray-700 lg:text-xl md:text-xl    text-base"
          >
            ✕
          </button>
          <h2 className="lg:text-2xl md:text-2xl text-base font-medium mb-4 text-center text-[#37474F]">
            {selectedPackage}
          </h2>
        </div>
        {selectedPackage !== "Customize Package" ? (
          <div className="border-top">
            <div className="border-gray-200 lg:px-6 md:px-6 px-4  mt-8 pb-2  border-b mb-8">
              <p className="text-[#333F3E]   font-semibold text-lg ">Service</p>
            </div>

            {getSelectedServices?.map((feature, index) => (
              <div
                key={index}
                className={`mb-1 rounded-md border-gray-200 lg:px-6  md:px-6  px-4 py-2 ${
                  index % 2 === 0 ? "bg-[#F7F7F7]" : ""
                }`}
              >
                <p className="text-gray-700 lg:text-lg md:text-base text-sm  ">
                  {feature}
                </p>
              </div>
            ))}
            <div className="">
              <div className="mt-8 border-[2px]   border-dashed border-[#2299D5] flex justify-between items-center rounded-lg p-2">
                <p className="text-gray-700 text-xl font-normal opacity-70">
                  Estimate price :
                </p>
                <p className="text-black bg-[#E3F7FF] px-8 rounded-md py-2 font-semibold ml-2">
                  Rs {getPrice}/
                </p>
              </div>
            </div>

            <div className="text-center mt-8 mb-4">
              <p className="text-center text-gray-500 text-sm mt-2">
                Get exclusive discounts — don’t miss out!
              </p>
              <button
                onClick={onConfirm}
                className=" bg-[#2299D5] font-georama text-white py-2 px-6 rounded-full hover:opacity-90 shadow-md transition mt-2"
              >
                Contact sales
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1  mt-4 sm:grid-cols-2 gap-4 px-4">
              {servicesList.map((service, index) => (
                <label
                  key={index}
                  onChange={() => handleCheckboxChange(service)}
                  className={`flex items-center p-3 rounded-md border border-gray-200 ${
                    selectedServices.includes(service)
                      ? "bg-[#E3F7FF]"
                      : "bg-white"
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selectedServices.includes(service)}
                    className="mr-2 h-4 cursor-pointer w-4 text-[#2299D5]  accent-[#2299D5] focus:ring-[#2299D5]  border-gray-300 "
                  />
                  <span className="text-gray-700 text-sm sm:text-base md:text-base">
                    {service}
                  </span>
                </label>
              ))}
            </div>
            <div className="text-center">
              <button
                onClick={onConfirm}
                className=" bg-[#2299D5] font-georama text-white py-2 px-6 rounded-full hover:opacity-90 shadow-md transition mt-3"
              >
                Contact sales
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ModalComponent;
